var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vendor-resources-group"},[_c('router-view',{attrs:{"force-root-view-refresh":_vm.forceRootViewRefresh,"signed-in-user":_vm.signedInUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }